import { render, staticRenderFns } from "./MonitorItemC228.vue?vue&type=template&id=d799cd34&scoped=true"
import script from "./MonitorItemC228.vue?vue&type=script&lang=js"
export * from "./MonitorItemC228.vue?vue&type=script&lang=js"
import style0 from "./MonitorItemC228.vue?vue&type=style&index=0&id=d799cd34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d799cd34",
  null
  
)

export default component.exports